import React from 'react';
import {OPEN_OVERLAY, CLOSE_OVERLAY} from './overlayTypes';
import {openMsg} from '../msg/msgActions';
import {dev} from 'lib.common';

export function closeOverlay() {
   return {
      type: CLOSE_OVERLAY
   };
}

export function openOverlay(
   Component,
   componentProps = {},
   callbackOnClose = null,
   containerProps = {}
) {
   return async function(dispatch) {
      const {display, zIndex, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               dispatch(closeOverlay());
            } else {
               dispatch(closeOverlay());
            }
         } catch (error) {
            dispatch(openMsg(dev.getErrorMsg(error)));
         }
      }
      dispatch({
         type: OPEN_OVERLAY,
         payload: {
            ...options,
            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={() => {
                     dispatch(closeOverlay());
                  }}
                  {...componentProps}
               />
            )
         }
      });
   };
}
